import { render, staticRenderFns } from "./TosLink.vue?vue&type=template&id=36c1d5ad&scoped=true&"
import script from "./TosLink.vue?vue&type=script&lang=js&"
export * from "./TosLink.vue?vue&type=script&lang=js&"
import style0 from "./TosLink.vue?vue&type=style&index=0&id=36c1d5ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c1d5ad",
  null
  
)

export default component.exports